import { Component, OnInit } from '@angular/core';
import { FormService } from 'src/app/services/form.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { SesionService } from 'src/app/services/sesion.service';
import { UtilsService } from 'src/app/services/utils.service';
import { AppConstants } from 'src/app/app.constants';
import { FormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { ModalService } from 'src/app/services/modal.service';
import { RecuperarcontraseniamodalComponent } from '../../modals/recuperarcontraseniamodal/recuperarcontraseniamodal.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  form: FormGroup;
  submitted: Boolean = false;
  isPassShow: Boolean = false;
  nombreSistema: String = environment.ENVIRONMENT.NOMBRE_SISTEMA;
  descripcionSistema: String = environment.ENVIRONMENT.DESCRIPCION_SISTEMA;

  constructor(private formService: FormService, private alerts: NotificacionesService,
    private sesionService: SesionService, private utils: UtilsService, private modal: ModalService) { }

  ngOnInit(): void {
    this.form = this.formService.getLoginForm();
  }

  login() {
    this.submitted = true;
    if (this.form.invalid)
      return;
    this.modal.mostrarModalCargando();
    this.sesionService.login(this.form.value).subscribe(result => {
      this.modal.cerrarModalCargando();
      let data: any = result;
      if (this.utils.validarObjeto(data) && data.codigo === AppConstants.RESPONSECODES.OK) {
        this.alerts.success(data.mensaje, true);
        data.contrasena = this.form.value.contrasena;
        this.sesionService.setSesionData(data);
        this.verificarAcceso();
      } else {
        this.alerts.error(this.utils.validarObjeto(data) ? data.mensaje : 'Credenciales inválidas, intente de nuevo', true);
      }
    }, error => {
      this.modal.cerrarModalCargando();
      console.error(error);
      this.alerts.error('No se pudo iniciar sesión con el usuario ingresado, verifique su conexion e intente de nuevo', true);
    });
  }

  showHidePassword() {
    this.isPassShow = !this.isPassShow;
  }

  verificarAcceso(): void {
    this.utils.redirectPath([AppConstants.APLICATION_MODULES.VERIFICAR_ACCESO.ruta], true);
  }

  showModal() {
    let modalRef = this.modal.mostrarModal(RecuperarcontraseniamodalComponent, 'lg');
    modalRef.result.then((data) => {
    }, (reason) => {
    });
  }

}
